import { RowsPerPageEnum } from './oneLink';

export const INITIAL_PAGE_SIZE = 50;
export const INITIAL_PAGE = 1;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const PER_PAGE_OPTIONS = [
  RowsPerPageEnum.Ten,
  RowsPerPageEnum.TwentyFive,
  RowsPerPageEnum.Fifty,
  RowsPerPageEnum.OneHundred,
];
